import { render, staticRenderFns } from "./PageTouristAgencies.vue?vue&type=template&id=630f5650&"
import script from "./PageTouristAgencies.vue?vue&type=script&lang=js&"
export * from "./PageTouristAgencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630f5650')) {
      api.createRecord('630f5650', component.options)
    } else {
      api.reload('630f5650', component.options)
    }
    module.hot.accept("./PageTouristAgencies.vue?vue&type=template&id=630f5650&", function () {
      api.rerender('630f5650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/touristAgencies/PageTouristAgencies.vue"
export default component.exports